// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Tq7DX","header-stand-in":"Header_header-stand-in__X2wjO","logo-container":"Header_logo-container__e6U61","logo":"Header_logo__IRZPi"};